import React, { useState } from "react";
import LoginTemplate from "../../templates/loginTemplate/LoginTemplate";
import AuthAPI from "../../apis/auth/AuthAPI";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet-async";
const LoginScreen = () => {
  const authApi = new AuthAPI();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const openSignUp = location.state?.openSignUp ?? false;

  // Mappe les messages d'erreur connus du backend (souvent en anglais)
  // vers un message affichable en français dans le toast.
  const translateBackendError = (detail) => {
    if (typeof detail !== "string") return null;

    const knownErrors = {
      "Email already registered":
        "Cette adresse e-mail est déjà utilisée. Veuillez en choisir une autre.",
    };

    return knownErrors[detail] || null;
  };

  const register = async (formData, resetForm, onError) => {
  console.log("📤 Payload sent to backend:", JSON.stringify(formData, null, 2));

  try {
    const response = await authApi.postRegister(formData);
    if (response.status === 200 || response.status === 201) {
      if (resetForm) resetForm();
      toast.success(
        "Compte créé avec succès ! Vous pouvez désormais recevoir des notifications par e-mail.",
        {
          duration: 5000,
          style: {
            background: "#1e2f3d",
            color: "#ffffff",
            border: "1px solid rgba(40, 196, 156, 0.45)",
            borderRadius: "14px",
            fontSize: "15px",
            fontWeight: "500",
            lineHeight: "1.5",
            padding: "18px 24px",
            maxWidth: "460px",
            backdropFilter: "blur(14px)",
            boxShadow: "0 0 24px rgba(40, 196, 156, 0.2), 0 8px 32px rgba(0,0,0,0.4)",
          },
          iconTheme: {
            primary: "#28c49c",
            secondary: "#1e2f3d",
          },
        }
      );
    }
  } catch (error) {
    const errorData = error?.response?.data;
    console.error("❌ 422 detail:", JSON.stringify(errorData, null, 2));

    // Forward the error to Register so it can show the inline field error
    if (onError && typeof onError === "function") {
      onError(errorData || {});
    }

    // Le backend renvoie le message d'erreur sous la clé "detail" et il est
    // souvent en anglais (ex: "Email already registered"). On traduit d'abord
    // les messages connus en français ; si le message est inconnu, on retombe
    // sur un message générique plutôt que d'afficher l'anglais brut.
    const rawDetail =
      typeof errorData?.detail === "string" ? errorData.detail : null;
    const backendMessage = translateBackendError(rawDetail);

    toast.error(
      backendMessage || "Inscription échouée. Veuillez réessayer.",
      {
        duration: 5000,
        style: {
          background: "#1e2f3d",
          color: "#ffffff",
          border: "1px solid rgba(225, 6, 19, 0.6)",
          borderRadius: "14px",
          fontSize: "15px",
          fontWeight: "500",
          lineHeight: "1.5",
          padding: "18px 24px",
          maxWidth: "460px",
          backdropFilter: "blur(14px)",
          boxShadow: "0 0 24px rgba(225, 6, 19, 0.2), 0 8px 32px rgba(0,0,0,0.4)",
        },
        iconTheme: {
          primary: "#e10613",
          secondary: "#1e2f3d",
        },
      }
    );
    console.error("register error", error);
  }
};

  return (
    <>
          <Helmet>
        <title>Inscription | Ensemble pour la Forêt</title>
        <meta
          name="description"
          content="Créez votre compte pour recevoir des alertes personnalisées sur le risque incendie dans votre région."
        />
      </Helmet>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#1e2f3d",
            color: "#ffffff",
            border: "1px solid rgba(225, 6, 19, 0.3)",
          },
        }}
      />
      <LoginTemplate
        navigate={navigate}
        initialSignUp={openSignUp}
        email={email}
        password={password}
        onChangeEmail={setEmail}
        onChangePassword={setPassword}
        register={register}
      />
    </>
  );
};

export default LoginScreen;